import cx from "classnames";
import React from "react";
import * as styles from "./OverlayBackdrop.module.css";
const OverlayBackdrop = ({
  testId = "overlay",
  type,
  animationState,
  onClose
}) => /* @__PURE__ */ React.createElement("div", {
  role: "presentation",
  className: cx(styles.root, {
    [styles.backdropEntering]: animationState === "entering",
    [styles.backdropEntered]: animationState === "entered",
    [styles.backdropExiting]: animationState === "exiting",
    [styles.backdropExited]: animationState === "exited",
    [styles.backdropMobileOnly]: type !== "modal"
  }),
  onClick: (e) => {
    e.stopPropagation();
    return onClose && onClose();
  },
  "data-testid": `${testId}-backdrop`
});
var OverlayBackdrop_default = OverlayBackdrop;
export {
  OverlayBackdrop_default as default
};
